import React from 'react'
import CustomerTable from './Componates/CustomersTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const CustomerList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Customers List</HeadingOne>
          <AddItemBtn url="add-customer" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <CustomerTable />
      </div>
    </PageBody>
  );
};

export default CustomerList;
